module.exports = __webpack_public_path__ + "img/crown1.c81bfe11.png";